// feedback.js
// Provides helpers for submitting LocalVoice feedback to the backend spreadsheet.
import { makeApiCallAsync } from '../firebase/functions';

const normalizeField = (value) => (typeof value === 'string' ? value.trim() : '');

export const submitFeedbackAsync = async ({
  origin,
  detailPage,
  vote,
  feedbackText,
  emailAddress,
}) => {
  const payload = {
    origin: normalizeField(origin),
    detailPage: normalizeField(detailPage),
    vote: normalizeField(vote),
    feedback: normalizeField(feedbackText),
    email: normalizeField(emailAddress),
  };

  await makeApiCallAsync('logFeedbackToSheet', payload);
};
